import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import { Id } from '../aliases'
import { type ImageObject, ImageObjectSchema } from './imageObject'

export type OrgSummary = {
  id?: Id
  name: string
  description?: string
  logos: ImageObject[]
}

export const OrgSummarySchema: CborSchema<OrgSummary> =
  defineCborSchema<OrgSummary>({
    id: CborField({ key: 0, required: false }),
    name: CborField({ key: 1 }),
    description: CborField({ key: 2, required: false }),
    logos: CborField({
      key: 3,
      arrayItemType: ImageObjectSchema,
    }),
  })
